export default (ctx, inject) => {
	const flags = (ctx.$config && ctx.$config.featureFlags) || {}

	const isEnabled = key => {
		return flags[key] === true
	}

	inject('featureFlags', {
		all: flags,
		isEnabled
	})
}
